<template>
  <!-- MONEY TRANSFER -->
  <v-modal
    :name="name"
    title="Solicitar créditos"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="2"
  >
    <v-inner>
      <div v-if="!action_success">
        <v-alert>
          Deseja já realizar o pedido de compra de créditos para essas
          {{ data.hours }} horas?
        </v-alert>
        <v-button class="primary" @click="buyCredit()"
          >Comprar créditos</v-button
        >
        <v-button class="gray" @click="hide()">Cancelar</v-button>
      </div>
      <div v-else>
        <v-text class="p-3">
          Recebemos a sua solicitação e em breve a nossa equipe financeira irá
          processá-la!</v-text
        >
        <v-button class="block primary" @click="hide()">Fechar</v-button>
      </div>
    </v-inner>
  </v-modal>
</template>

<script>
import clientApi from '@/api/client';

export default {
  props: {
    show: {
      default: false,
    },
    title: {
      default: '',
    },
    name: {
      default: 'modal',
    },
    size: {
      default: 3,
    },
    profile: {
      default: 'client',
    },
    data: {},
  },
  components: {},
  data() {
    return {
      action_success: false,
    };
  },
  methods: {
    hide() {
      this.onHide();
      this.show = false;
    },
    onHide() {
      this.refresh = false;
      this.$emit('onHide');
      // OK vars
      this.action_success = false;
    },
    buyCredit() {
      var credits = [];
      this.data.contract.buy_hours = this.data.hours;
      credits.push(this.data.contract);
      clientApi
        .buyContractCredits(credits)
        .then(response => {
          if (response.status === 200) {
            console.log('teste');
            this.action_success = true;
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/parts/modals/request-credit.vue